export const TRIAL_DAYS = 30;

export const SUBSCRIPTION_PLANS = [
  {
    key: "small",
    productId: "prod_Q9dw1U8e1LDfCr",
    employeeLimit: 10,
    monthlyPrice: 39.95,
  },
  {
    key: "medium",
    productId: "prod_Q9dwC9yKSDJhpa",
    employeeLimit: 24,
    monthlyPrice: 59.95,
  },
  {
    key: "large",
    productId: "prod_Q9dwqqoUiuFriF",
    employeeLimit: 39,
    monthlyPrice: 69.95,
  },
];

export const SUBSCRIPTION_ADDONS = [
  {
    key: "punch_clock",
    products: {
      small: { productId: "prod_Q9dwSlduqUIAib", monthlyPrice: 8 },
      medium: { productId: "prod_Q9dwQnXa4BL0ol", monthlyPrice: 10 },
      large: { productId: "prod_Q9dw2vO0BdRk2y", monthlyPrice: 14 },
    },
  },
  {
    key: "whatsapp",
    products: {
      small: { productId: "prod_Q9dv0vvGInda13", monthlyPrice: 8 },
      medium: { productId: "prod_Q9dwjp1pT1hiU7", monthlyPrice: 14 },
      large: { productId: "prod_Q9dwS9e7BwM8Og", monthlyPrice: 20 },
    },
  },
];

export function planForEmployeeCount(employeeCount) {
  const normalizedCount = Math.max(1, Number(employeeCount) || 1);
  return (
    SUBSCRIPTION_PLANS.find((plan) => normalizedCount <= plan.employeeLimit)
    || SUBSCRIPTION_PLANS[SUBSCRIPTION_PLANS.length - 1]
  );
}

export function planForKey(planKey) {
  return SUBSCRIPTION_PLANS.find((plan) => plan.key === planKey) || null;
}

export function selectedProductIds(plan, selectedAddonKeys) {
  if (!plan) return [];

  const addonProductIds = SUBSCRIPTION_ADDONS
    .filter((addon) => selectedAddonKeys.includes(addon.key))
    .map((addon) => addon.products[plan.key]?.productId)
    .filter(Boolean);

  return [plan.productId, ...addonProductIds];
}

export function monthlyPriceForSelection(plan, selectedAddonKeys) {
  if (!plan) return 0;

  return SUBSCRIPTION_ADDONS
    .filter((addon) => selectedAddonKeys.includes(addon.key))
    .reduce(
      (total, addon) => total + Number(addon.products[plan.key]?.monthlyPrice || 0),
      plan.monthlyPrice
    );
}

export function subscriptionViewState(subscription) {
  if (Number(subscription?.trial_days_remaining || 0) > 0) return "trial";
  if (subscription?.status === "pending_invoice" && subscription?.is_active) return "pending";
  if (subscription?.is_active) return "active";
  return "expired";
}

export function trialDay(trialDaysRemaining, trialDaysTotal = TRIAL_DAYS) {
  const total = Math.max(1, Number(trialDaysTotal) || TRIAL_DAYS);
  return Math.min(total, Math.max(1, total - Number(trialDaysRemaining || 0)));
}
